import React from 'react';
import './btn.css';

export const DeliveryBtn = () => {

    return (
        <button className="btn btn-danger margin_right_envelope btnColor">
            <i className="fas fa-user-alt icon"> </i>
            <span className="navbar-brand user">
                ALBARANES
            </span>
        </button>
    )
}